module.exports = __webpack_public_path__ + "media/images/icons/v2/settings-02-8d4bbe864192bf4b96ce3e170603a52b.svg";